import { render, staticRenderFns } from "./acceptanceProductRecord.vue?vue&type=template&id=8dbde220&scoped=true"
import script from "./acceptanceProductRecord.vue?vue&type=script&lang=js"
export * from "./acceptanceProductRecord.vue?vue&type=script&lang=js"
import style0 from "./acceptanceProductRecord.vue?vue&type=style&index=0&id=8dbde220&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbde220",
  null
  
)

export default component.exports